/**
 * Initialize tabs functionality
 * @param {HTMLElement} container - The container element for the tabs
 */
export function initTabs(container) {
  const tabButtons = container.querySelectorAll('.uom-tab');
  const tabPanels = container.querySelectorAll('.uom-tab-content');
  const tabList = container.querySelector('.uom-tabs');

  // Function to activate a tab
  const activateTab = (index) => {
    const tabs = Array.from(container.querySelectorAll('.uom-tab'));
    const tabContents = Array.from(
      container.querySelectorAll('.uom-tab-content')
    );

    // Remove active class from all tabs and contents
    tabs.forEach((tab) => {
      tab.classList.remove('active');
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
    });
    tabContents.forEach((content) => content.classList.remove('active'));

    // Add active class to specified tab and content
    tabs[index].classList.add('active');
    tabs[index].setAttribute('aria-selected', 'true');
    tabs[index].setAttribute('tabindex', '0');
    tabs[index].focus();
    tabContents[index].classList.add('active');
  };

  tabButtons.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      // Update active states
      activateTab(index);
    });
  });

  tabList.addEventListener('keydown', (event) => {
    const tabs = Array.from(container.querySelectorAll('.uom-tab'));
    const currentIndex = tabs.findIndex((tab) =>
      tab.classList.contains('active')
    );
    let newIndex = currentIndex;

    switch (event.key) {
      case 'ArrowRight':
        newIndex = (currentIndex + 1) % tabs.length;
        event.preventDefault();
        break;
      case 'ArrowLeft':
        newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        event.preventDefault();
        break;
      case 'Home':
        newIndex = 0;
        event.preventDefault();
        break;
      case 'End':
        newIndex = tabs.length - 1;
        event.preventDefault();
        break;
      default:
        return; // Exit for other keys
    }

    if (newIndex !== currentIndex) {
      activateTab(newIndex);
    }
  });
}

// Initialize all tab components on the page
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.uom-tabs-container').forEach((container) => {
    initTabs(container);
  });
});
